import Handlebars from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.9/js/handlebars";
/**
 * Unique Link helper - updates link id at build time
 * This is a temporary solution until another one is created on the Platform side where
 * the same link helper can be used with different link ids inside of jcrs
 * Author: Yelena Rose (zkymyru)
 */


const helpers = {
  /**
   * Appends a string to the existing link id
   * @param {string} linkOrText  - original link
   * @param {string} appendString - will be appended to the existing id
   * @return {string} link
   */
  appendToLinkID(linkOrText, appendString) {
    if (typeof (linkOrText) === 'string' && typeof (appendString) === 'string') {
      return linkOrText.replace(/<a id='(.*?)'/g, `<a id=$1${appendString}`);
    }
    return linkOrText;
  },
};

module.exports.register = (Handlebars) => {
  Object.keys(helpers).forEach((helper) => {
    Handlebars.registerHelper(helper, helpers[helper]);
  });
};

module.exports.helpers = helpers;
